import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import pages from './pages/index';
import { UserProvider } from './contexts/UserContext';
import { ProjectProvider } from './contexts/ProjectContext';
import { ReportProvider } from './contexts/ReportContext';
import { ThemeProvider } from './contexts/ThemeContext';
import { initWebSocket } from './services/socket';
import AdminLayout from './components/Admin/AdminLayout';
import AdminDashboard from './pages/Admin/AdminDashboard';
import AdminClients from './pages/Admin/AdminClients';
import AdminClientDetail from './pages/Admin/AdminClientDetail';
import AdminRegistrations from './pages/Admin/AdminRegistrations';
import AdminRegistrationDetail from './pages/Admin/AdminRegistrationDetail';
import AdminPayments from './pages/Admin/AdminPayments';
import AdminInquiries from './pages/Admin/AdminInquiries';
import AdminInquiryDetail from './pages/Admin/AdminInquiryDetail';

const AppRoutes: React.FC = () => {
  return (
    <div className="appWrapper">
      <Routes>
          <Route path="/admin" element={<AdminLayout />}>
            <Route index element={<AdminDashboard />} />
            <Route path="clients" element={<AdminClients />} />
            <Route path="clients/:id" element={<AdminClientDetail />} />
            <Route path="registrations" element={<AdminRegistrations />} />
            <Route path="registrations/:id" element={<AdminRegistrationDetail />} />
            <Route path="payments" element={<AdminPayments />} />
            <Route path="inquiries" element={<AdminInquiries />} />
            <Route path="inquiries/:id" element={<AdminInquiryDetail />} />
          </Route>
          {pages.map(({ path, Component }) => (
            <Route key={path} path={path} element={<Component />} />
          ))}
      </Routes>
    </div>
  );
};


const App: React.FC = () => {
  useEffect(() => {
    const ws = initWebSocket();
    return () => {
      ws?.close();
    };
  }, []);
  return (
    <Router>

      <UserProvider>
        <ThemeProvider>
          <ProjectProvider>
            <ReportProvider>
              <AppRoutes />
            </ReportProvider>
          </ProjectProvider>
        </ThemeProvider>
      </UserProvider>
    </Router>
  );
};

export default App;
